import { render, staticRenderFns } from "./CountedServiceCards.vue?vue&type=template&id=06a69758&"
import script from "./CountedServiceCards.vue?vue&type=script&lang=js&"
export * from "./CountedServiceCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports